import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: relative;
  user-select: none;

  .rating {
    &__error {
      color: ${(props) => props.theme.danger};
    }
  }

  ${(props) =>
    props.disabled &&
    css`
      :before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
      }
    `}
`
